// Libarary
import { Injectable } from '@angular/core';

// Service
import { ConfigService } from '../infrastructure/config.service';
import { NetworkService } from '../infrastructure/network.service';

@Injectable()
export class CppManageSubscription {
  constructor(public configService: ConfigService,
    private networkService: NetworkService) {
  }

  // Get Cpp Price List
  public getManageSubscriptionList(accountNo) {
    return this.networkService.getRequest(this.configService.getManageSubscriptionList() + '?accountNo=' + accountNo);
  }

  public getSubscriptionStatus(accountNo) {
    return this.networkService.getRequest(this.configService.getSubscriptionStatus() + '?accountNo=' + accountNo);
  }

  public updateStatus(accountNo, subscriptionType, changesOnly, displayAPR, changeType, update = false) {
    return this.networkService.getRequest(this.configService.updateStatus() + '?accountNo=' + accountNo + '&subscriptionType=' + subscriptionType + '&changesOnly=' + changesOnly + '&displayAPR=' + displayAPR + '&update=' + update + '&changeType=' + changeType);
  }

  public addUpdateSubscription(isSubscribe, showChanges, subscriptionType, displayAPR, changeType, filters) {
    return this.networkService.postRequest(this.configService.addUpdateSubscription() + '?isSubscribe=' + isSubscribe + '&showChanges=' + showChanges + '&subscriptionType=' + subscriptionType + '&displayAPR=' + displayAPR + '&changeType=' + changeType, filters);
  }

  public isValidForSubscription() {
    return this.networkService.getRequest(this.configService.isValidForSubscription());
  }
}
